import React, { FC, ReactNode, ElementType } from 'react'

import cn from 'classnames'
import { Link } from 'react-router-dom'

import classes from './text-link.module.scss'

interface TextLinkProps {
  children: ReactNode
  onClick?: React.MouseEventHandler<HTMLElement>
  to?: string
  href?: string
  className?: string
  size?: number
  tag?: ElementType
  hasTarget?: boolean
  tabIndex?: number
  dataTestId?: string
  role?: string
}

const TextLink: FC<TextLinkProps> = ({
  tag: Tag = Link,
  hasTarget = false,
  onClick,
  to = '',
  size = 1,
  className = '',
  tabIndex = 0,
  dataTestId = 'text-link',
  ...props
}: TextLinkProps) => {
  const target = hasTarget ? '_blank' : undefined
  const rel = hasTarget ? 'noopener noreferrer' : undefined

  return (
    <Tag
      tabIndex={tabIndex}
      target={target}
      rel={rel}
      to={to}
      onClick={onClick}
      data-testid={dataTestId}
      className={cn(classes.root, classes[`size${size}`], className)}
      {...props}
    />
  )
}

export { TextLink }
export default TextLink
